/* eslint-disable import/no-default-export */
import { forNamespace, localizeCount } from 'app/common/lib/util/i18n';
import React from 'react';
import styles from './free-board-limit-info.less';

const format = forNamespace('free board limit board create info', {
  shouldEscapeStrings: false,
});

interface FreeBoardLimitInfoProps {
  isInline?: boolean;
  isAtOrOverLimit?: boolean;
  isLimitOverridden?: boolean;
  isDesktop?: boolean;
  openBoardCount: number;
  orgName: string;
  upgradeUrl: string;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
}

const getText = ({
  isAtOrOverLimit,
  openBoardCount,
  orgName,
  upgradeUrl,
  isDesktop,
  isLimitOverridden,
}: FreeBoardLimitInfoProps) => {
  // Localize the translations to be used within other translations (translaception)
  const openBoards = localizeCount('open-boards', openBoardCount);
  const upgradeLink = (
    <a key="upgrade-link" href={upgradeUrl}>
      {format('upgrade to business class', { orgName })}
    </a>
  );

  if (!isDesktop && !isAtOrOverLimit) {
    return format('warn on web', {
      openBoards,
      upgradeLink,
    });
  }

  if (!isDesktop && isAtOrOverLimit) {
    return format('block on web', {
      upgradeLink,
    });
  }

  if (isDesktop && !isAtOrOverLimit) {
    return format('warn on desktop', {
      orgName,
      openBoards,
    });
  }

  if (isDesktop && isAtOrOverLimit) {
    return format('block on desktop');
  }
};

const FreeBoardLimitInfo: React.FunctionComponent<FreeBoardLimitInfoProps> = ({
  onMouseEnter,
  onMouseLeave,
  isInline,
  ...otherProps
}) => (
  <div
    className={isInline ? styles.purpleBox : styles.whiteBox}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <p>{getText(otherProps)}</p>
    <div className={styles.learnMoreLinkContainer}>
      <a
        className={styles.learnMoreLink}
        href="https://help.trello.com/article/1177-personal-vs-team-boards"
        target="_blank"
        rel="noopener noreferrer"
      >
        {format('learn more')}
      </a>
    </div>
  </div>
);

export default FreeBoardLimitInfo;
